import cn from 'classnames';
import React, { FunctionComponent } from 'react';
import styles from './InlineFormContainer.scss';

export interface InlineFormContainerProps {
  qaAttribute?: string;
  error?: string | JSX.Element;
  touched?: boolean;
  className?: string;
}

const InlineFormContainer: FunctionComponent<InlineFormContainerProps> = ({
  qaAttribute,
  error,
  touched,
  className,
  children,
}) => {
  const isErrored = (touched ?? false) && (error ?? false);
  return (
    <div
      className={cn(styles.inlineFormContainer, className ?? '')}
      data-qa={qaAttribute ? 'inline-form-container-' + qaAttribute : ''}
    >
      <div className={styles.elements}>{children}</div>
      {isErrored ? (
        <span className="jg-form-error-copy" role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default InlineFormContainer;
